import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

// Components
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import Industry from "./pages/Industry";
import CaseStudy from "./pages/CaseStudy";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-xgrids-bg-primary">
            {/* Noise overlay */}
            <div className="noise-overlay" />
            
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/produk" element={<Layout><Products /></Layout>} />
              <Route path="/industri" element={<Layout><Industry /></Layout>} />
              <Route path="/case-study" element={<Layout><CaseStudy /></Layout>} />
              <Route path="/tentang" element={<Layout><About /></Layout>} />
              <Route path="/admin" element={<Layout><AdminLogin /></Layout>} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            
            <Toaster 
              position="top-right"
              toastOptions={{
                style: {
                  background: '#121214',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff'
                }
              }}
            />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
